import { useCallback } from "react";

import { TerritoryLevel } from "@mapmycustomers/shared";
import MapTool from "@mapmycustomers/shared/enum/map/MapTool";

import colors from "@app/styles/_colors.module.scss";

import { DemographicRegionItem } from ".";

const useStyleGetter = (
  currentLevel: TerritoryLevel,
  hoveredRegion: DemographicRegionItem | undefined,
  level: TerritoryLevel,
  selectedTool: MapTool | undefined,
  tooltipPosition: google.maps.LatLngLiteral | undefined,
  visualizeDemography: boolean,
  zIndex: number | undefined
) => {
  const regionStyleGetter = useCallback(
    (region: DemographicRegionItem) => {
      let strokeWeight = 0.5;
      if (region.level === currentLevel) {
        strokeWeight = visualizeDemography && region.level !== TerritoryLevel.ADM1 ? 0 : 0.5;
      } else if (
        (region.level === TerritoryLevel.ADM1 && currentLevel === TerritoryLevel.ADM2) ||
        (region.level === TerritoryLevel.ADM2 && currentLevel === TerritoryLevel.ADM3)
      ) {
        strokeWeight = 1;
      } else if (region.level === TerritoryLevel.ADM1 && currentLevel === TerritoryLevel.ADM3) {
        strokeWeight = 1.5;
      }
      return {
        clickable: selectedTool !== MapTool.LASSO && currentLevel === region.level,
        cursor: tooltipPosition ? "grab" : "pointer",
        draggable: false,
        fillColor:
          region.color && visualizeDemography && region.visible ? region.color : "transparent",
        fillOpacity: region.color && visualizeDemography && region.level === currentLevel ? 1 : 0,
        strokeColor: colors.slate,
        strokeOpacity:
          visualizeDemography &&
          hoveredRegion?.id !== region.id &&
          region.visible &&
          region.level === level &&
          region.level !== TerritoryLevel.ADM1
            ? 0
            : 1,
        strokeWeight: visualizeDemography && hoveredRegion?.id === region.id ? 4 : strokeWeight,
        zIndex,
      };
    },
    [
      currentLevel,
      hoveredRegion?.id,
      level,
      selectedTool,
      tooltipPosition,
      visualizeDemography,
      zIndex,
    ]
  );

  return regionStyleGetter;
};

export default useStyleGetter;
